import { Result } from './../../../../../src/app/shared/class/result.model';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { UsuarioAccesoExtemporaneo, UsuarioMeta, UsuarioModulo, UsuarioOficina, UsuarioPersonal } from './accesos-class/accesos.model';

@Injectable({
  providedIn: 'root'
})
export class AccesosService {

  private domain = environment.url;

  constructor(private http: HttpClient) { }

  guardar_usuario(usuario: UsuarioPersonal) {
    const url = `${this.domain}/personal/guardar_usuario`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, usuario, { headers: headers }).pipe(map(data => data));
  }

  login(username: string, password: string) {
    const url = `${this.domain}/personal/login`;
    const body = JSON.stringify({
      username: username,
      password: password
    });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, body, { headers: headers }).pipe(map(data => data));
  }

  cambiarPassword(uid: string, password: string) {
    const url = `${this.domain}/personal/change/password`;
    const body = JSON.stringify({ uid: uid, password: password });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, body, { headers: headers }).pipe(map(data => data));
  }

  asignarModuloAUsuario(data: UsuarioModulo, selected: number) {
    const url = `${this.domain}/personal/asignar/modulo/usuario/${selected}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, data, { headers: headers }).pipe(map(data => data));
  }

  listar_usuarios() {
    const url = `${this.domain}/personal/listar_usuarios`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  listarAccesosUsuarios(nombres: string, meta: string, estado: boolean, itemsPorPagina: number, pagina: number) {
    const url = `${this.domain}/personal/listar/accesos/usuarios`;
    const body = JSON.stringify({
      nombres: nombres,
      meta: meta,
      estado: estado,
      items_por_pagina: itemsPorPagina,
      pagina: pagina
    });
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, body, { headers: headers }).pipe(map(data => data));
  }


  listar_modulos() {
    const url = `${this.domain}/personal/listar_modulos`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  deshabilitarUsuarios(uid: string) {
    const url = `${this.domain}/personal/deshabilitar/usuario/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.delete<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  habilitarUsuarios(uid: string) {
    const url = `${this.domain}/personal/habilitar/usuario/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.put<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  listarUsuariosOficinas(uid: string) {
    const url = `${this.domain}/personal/listar/usuario/oficinas/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  guardarUsuarioOficina(usuarioOficina: UsuarioOficina) {
    const url = `${this.domain}/personal/guardar/usuario/oficina`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, usuarioOficina, { headers: headers }).pipe(map(data => data));
  }

  eliminarUsuarioOficina(id: number) {
    const url = `${this.domain}/personal/eliminar/usuario/oficina/${id}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.delete<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  listarUsuariosMetas(uid: string) {
    const url = `${this.domain}/personal/listar/usuario/metas/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  guardarUsuarioMeta(usuarioMeta: UsuarioMeta) {
    const url = `${this.domain}/personal/guardar/usuario/meta`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, usuarioMeta, { headers: headers }).pipe(map(data => data));
  }

  eliminarUsuarioMeta(id: number) {
    const url = `${this.domain}/personal/eliminar/usuario/meta/${id}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.delete<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  listarModulosDeUsuario(uid: string) {
    const url = `${this.domain}/personal/listar/modulos/usuario/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  listarAccesosUsuarioModulos(uid: string) {
    const url = `${this.domain}/personal/listar/accesos/usuario/modulos/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  /* Accesos extemporaneos */
  listarAccesosExtemporaneos(uid: string) {
    const url = `${this.domain}/personal/usuario/listar_acceso_extemporaneo/${uid}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  buscarAccesoExtemporaneo(uid: string, modulo: string, nroMeta: string) {
    const url = `${this.domain}/personal/usuario/buscar_acceso_extemporaneo/${uid}/${modulo}/${nroMeta}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  validarAccesoExtemporaneo(uid: string, modulo: string, nroMeta: string) {
    const url = `${this.domain}/personal/usuario/validar_acceso_extemporaneo/${uid}/${modulo}/${nroMeta}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, { headers: headers }).pipe(map(data => data));
  }

  guardarAccesoExtemporaneo(acceso: UsuarioAccesoExtemporaneo) {
    const url = `${this.domain}/personal/usuario/guardar_acceso_extemporaneo`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url, acceso, { headers: headers }).pipe(map(data => data));
  }

  eliminarAccesoExtemporaneo(id: number) {
    const url = `${this.domain}/personal/usuario/eliminar_acceso_extemporaneo/${id}`;
    const headers = new HttpHeaders().
      set('Content-Type', 'application/json; charset=utf-8');
    return this.http.delete<Result>(url, { headers: headers }).pipe(map(data => data));
  }

}
